/* unplugin-vue-components disabled */import { render } from "./Ticket2.vue?vue&type=template&id=48b5a893"
import script from "./Ticket2.vue?vue&type=script&lang=js"
export * from "./Ticket2.vue?vue&type=script&lang=js"

import "./Ticket2.vue?vue&type=style&index=0&id=48b5a893&lang=css"

import exportComponent from "/home/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__